import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var PictureIcon32Regular = forwardRefAndName('PictureIcon32Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 32
    }, props), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.50005 11C8.50005 9.067 10.0671 7.5 12.0001 7.5C13.933 7.5 15.5001 9.067 15.5001 11C15.5001 12.933 13.933 14.5 12.0001 14.5C10.0671 14.5 8.50005 12.933 8.50005 11ZM12.0001 9.5C11.1716 9.5 10.5001 10.1716 10.5001 11C10.5001 11.8284 11.1716 12.5 12.0001 12.5C12.8285 12.5 13.5001 11.8284 13.5001 11C13.5001 10.1716 12.8285 9.5 12.0001 9.5Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M17.2114 17.3577C17.7972 16.7719 18.7469 16.7719 19.3327 17.3577L22.4381 20.4631C22.8286 20.8536 23.4618 20.8536 23.8523 20.4631C24.2428 20.0725 24.2428 19.4394 23.8523 19.0488L20.7469 15.9435C19.3801 14.5766 17.164 14.5766 15.7972 15.9435L8.70469 23.036C8.31416 23.4265 8.31416 24.0597 8.70469 24.4502C9.09521 24.8407 9.72838 24.8407 10.1189 24.4502L17.2114 17.3577Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 7.5C4 4.46243 6.46243 2 9.5 2H18.2261C19.287 2 20.3044 2.42143 21.0546 3.17157L26.8284 8.94543C27.5786 9.69558 28 10.713 28 11.7739V24.5C28 27.5376 25.5376 30 22.5 30H9.5C6.46243 30 4 27.5376 4 24.5V7.5ZM9.5 4C7.567 4 6 5.567 6 7.5V24.5C6 26.433 7.567 28 9.5 28H22.5C24.433 28 26 26.433 26 24.5V11.7739C26 11.2434 25.7893 10.7347 25.4142 10.3596L19.6404 4.58579C19.2653 4.21071 18.7566 4 18.2261 4H9.5Z"
    }))
  );
});